import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";

export default function PricingCard({ pkg, index = 0, monthlyIncludesLabel = "Monthly Includes" }) {
  const isRec = pkg.recommended;
  return (
    <div
      data-testid={`pricing-card-${pkg.id}`}
      className={`relative flex flex-col p-8 lg:p-10 border rounded-sm bg-[#0e0e0e] transition-all duration-500 ${
        isRec
          ? "border-[#C8A24B] shadow-[0_0_60px_-20px_rgba(200,162,75,0.25)]"
          : "border-[#27272a] hover:border-[#3f3f46]"
      }`}
    >
      {isRec && (
        <div className="absolute -top-3 left-8 px-3 py-1 bg-[#C8A24B] text-[#0a0a0a] text-[10px] font-heading font-semibold tracking-[0.2em] uppercase">
          Recommended
        </div>
      )}
      <div className="text-[10px] tracking-[0.28em] uppercase text-[#71717a]">
        Tier 0{index + 1}
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <h3 className="font-heading text-3xl text-white">{pkg.name}</h3>
      </div>
      <p className="mt-3 text-[#C8A24B] text-sm font-medium tracking-wide">
        {pkg.tagline}
      </p>

      <div className="mt-8 pb-8 border-b border-[#27272a]">
        <div className="flex items-baseline gap-2">
          <span className="font-heading text-4xl lg:text-5xl text-white">
            {pkg.setup}
          </span>
          <span className="text-xs text-[#71717a] uppercase tracking-widest">
            setup
          </span>
        </div>
        <div className="mt-2 flex items-baseline gap-1">
          <span className="font-heading text-xl text-white/80">
            {pkg.monthly}
          </span>
          <span className="text-xs text-[#71717a]">{pkg.monthlyLabel}</span>
        </div>
      </div>

      <div className="mt-6">
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#71717a] mb-3">
          Best For
        </div>
        <p className="text-sm text-[#d4d4d8] leading-relaxed">{pkg.best}</p>
      </div>

      <div className="mt-8 flex-1">
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#71717a] mb-4">
          Included
        </div>
        <ul className="space-y-2.5">
          {pkg.features.map((f) => (
            <li key={f} className="flex items-start gap-2.5 text-sm">
              <Check
                size={14}
                className="text-[#C8A24B] flex-shrink-0 mt-0.5"
              />
              <span className="text-[#d4d4d8]">{f}</span>
            </li>
          ))}
        </ul>
        {pkg.monthlyIncludes && (
          <div className="mt-8">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#71717a] mb-4">
              {monthlyIncludesLabel}
            </div>
            <ul className="space-y-2">
              {pkg.monthlyIncludes.map((m) => (
                <li key={m} className="text-[13px] text-[#a1a1aa]">
                  {m}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <Link
        to="/contact"
        data-testid={`pricing-cta-${pkg.id}`}
        className={`${
          isRec ? "btn-gold" : "btn-outline"
        } mt-10 w-full justify-between`}
      >
        {pkg.cta}
        <ArrowRight size={16} />
      </Link>
    </div>
  );
}
